import { Component, ChangeDetectionStrategy } from '@angular/core';

/** `<sui-menu-separator>` — a non-interactive divider between groups of items. */
@Component({
  selector: 'sui-menu-separator',
  standalone: true,
  template: '',
  host: { role: 'separator' },
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: block;
        height: var(--border-width-thin);
        margin: var(--space-4) 0;
        background-color: var(--menu-separator);
      }
    `,
  ],
})
export class SuiMenuSeparatorComponent {}
